// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2LIvn","title":"ClientReferral_title__3y0Ad","itemText":"ClientReferral_itemText__3PMuD"};